import React from 'react';
import { Popover } from 'antd';
import NumberFormat from 'react-number-format';
import TextTruncate from 'react-text-truncate';
import { stripHtml } from '@/utils/helpers';
import {
    getDepositStatusLabel,
    getReceiptCurrentContent,
} from '@/utils/receiptCollectionResult';

/** Nội dung thu dùng chung cho danh sách phiếu thu và lịch sử thanh toán khách hàng. */
export default function ReceiptContentCell({ receipt, canViewDetail = false, onViewReceipt }) {
    const items = Array.isArray(receipt?.items) ? receipt.items : [];
    const isDeposit = receipt?.collection_purpose === 'DEPOSIT';
    const depositInfo = receipt?.deposit_info || {};
    const contentText = getReceiptCurrentContent(receipt);
    const canOpenDetail = canViewDetail && typeof onViewReceipt === 'function';
    const openDetail = () => {
        if (canOpenDetail && receipt?.id) onViewReceipt(receipt.id);
    };
    const triggerClassName = canOpenDetail ? 'item-action-btn' : undefined;

    if (isDeposit) {
        const targetServiceNames = depositInfo.current_target_service_names
            || depositInfo.target_service_names
            || [];
        const targetNames = Array.isArray(targetServiceNames) ? targetServiceNames : [];
        const popoverContent = <div style={{ minWidth: 260, maxWidth: 420 }}>
            <div style={{ marginBottom: 6 }}><strong>Nội dung:</strong> {stripHtml(contentText)}</div>
            <div style={{ marginBottom: 6 }}>
                <strong>Dịch vụ dự kiến:</strong> {targetNames.length ? targetNames.join(', ') : 'Chưa xác định'}
            </div>
            <div>
                <strong>Số dư cọc:</strong>{' '}
                <NumberFormat value={depositInfo.current_balance || 0} displayType="text" thousandSeparator />
                {' · '}{getDepositStatusLabel(depositInfo.status)}
            </div>
        </div>;

        return <Popover placement="right" content={popoverContent}>
            <div className={triggerClassName} onClick={openDetail}>
                <TextTruncate line={2} truncateText="…" text={stripHtml(contentText)} />
                {depositInfo.deposit_id && <div style={{ marginTop: 4, color: '#595959', fontSize: 12 }}>
                    Còn lại: <NumberFormat value={depositInfo.current_balance || 0} displayType="text" thousandSeparator />
                    {' · '}{getDepositStatusLabel(depositInfo.status)}
                </div>}
            </div>
        </Popover>;
    }

    if (!items.length) return '—';

    const popoverContent = items.map((item, index) => <div key={item.id || index} style={{ padding: '5px 0' }}>
        {index + 1}. {item.name}
    </div>);
    return <Popover placement="right" content={popoverContent}>
        <div className={triggerClassName} onClick={openDetail}>
            <TextTruncate line={1} truncateText="…" text={stripHtml(items[0]?.name)} />
        </div>
    </Popover>;
}
